module.exports = __webpack_public_path__ + "img/serve8.3047c172.png";